import { combineReducers } from "redux";
import getAccountDetails from "./getAccountDetails";
import guestRegister from "./guestRegister";
import guestValidateMPIN from "./GuestValidateMPIN";
import ClientLoginDataReducers from "./ClientLoginData";
import unblockUser from "./unblockUser";
import ClientForgotUserID from "./ClientForgotUserID";
import ClientGenOTP from "./ClientGenOTP";
import ClientSetPassword from "./ClientSetPassword";
import ClientValPassword from "./ClientValPassword";
import ClientValOTP from "./ClientValOTP";
import GuestEmailVerifyOTP from "./GuestEmailVerifyOTP";
export default combineReducers({
    guestRegister,
    getAccountDetails,
    guestValidateMPIN,
    ClientLoginDataReducers,
    unblockUser,
    ClientForgotUserID,
    ClientGenOTP,
    ClientSetPassword,
    ClientValPassword,
    ClientValOTP,
    GuestEmailVerifyOTP,
});
